/* eslint-disable max-lines */
import type { IPLWidgetControllerCards } from "@swiggy-private/dls-react-mxn/dist/WidgetController/PLWidgetController/type";
import { IAnalytics } from "@swiggy-private/dls-react-mxn/dist/WidgetController/type";
import type { IPopUpWidgetProps } from "@swiggy-private/dls-react-mxn/dist/WidgetController/widgets/PopUpWidget/types";
import { ApiResponse } from "@swiggy-private/js-utils/dist/fetch/types";
import { QrCodeActions } from "./qrCodeActions";
import type { ILocalCart } from "../types/cartTypes";

export interface IPopUpConfig {
    configInfo: Array<{
        card: IPopUpWidgetProps;
    }>;
}

export interface IApiConfigs {
    POPUP?: IPopUpConfig;
}

interface IBaseScreenState {
    data: ApiResponse<{ cards: IPLWidgetControllerCards[]; configs?: IApiConfigs }>;
    loading: boolean;
    error: boolean;
    lastUpdated: number;
}

export type AppliedFilters = {
    singleSelect: Record<string, string>;
    multiSelect: Record<string, string[]>;
};

interface IMenuLikeState extends IBaseScreenState {
    initialData: IPLWidgetControllerCards[];
    filteredData: IPLWidgetControllerCards[];
    parentType: string;
    categoryId: string;
    preference: string;
    emptyItemCard?: boolean;
    appliedFilters?: AppliedFilters;
    requestId?: string;
    configs?: IApiConfigs;
}

export interface ICrossSellEntry {
    itemId: string;
    itemName: string;
    isExpanded: boolean;
    cartItemIdsAtOpen?: string[];
}

export interface ITextPayload {
    info?: string;
    color?: string;
    font?: string;
}

export interface CrossSellConfig {
    "@type"?: string;
    crossSell?: {
        crossSellPerItem?: {
            crossSellMap?: Record<
                string,
                {
                    rawChildItems?: Array<{
                        id: string;
                        analytics?: IAnalytics;
                    }>;
                }
            >;
        };
        crossSellConstraints?: {
            minItems?: number;
            maxItems?: number;
        };
    };
    title?: string;
    title_v2?: ITextPayload;
    description_v2?: ITextPayload;
    imageUrl?: string;
    frequencyCapping?: number;
}

export enum ToastType {
    ERROR = "ERROR",
    INFO = "INFO",
    SUCCESS_TICK = "SUCCESS_TICK",
    SUCCESS = "SUCCESS",
}

export interface IReducerResponse {
    track: IBaseScreenState;
    placeOrderFailure: IBaseScreenState & {
        isFullScreenError: boolean;
    };
    menu: IMenuLikeState;
    billSummary: IBaseScreenState & {
        errorInfo: Record<string, string>;
    };
    cart: IBaseScreenState & {
        localCart: ILocalCart;
        isChildOrderExist?: boolean | null;
    };
    curtain: IBaseScreenState;
    pin: {
        data: Record<string, string>;
        loading: boolean;
        error: boolean;
        lastUpdated: number;
    };
    toast: {
        type: ToastType;
        message: string;
        show: boolean;
        autoDismiss?: boolean;
        autoDismissTime?: number;
    };
    paymentFailure: {
        show: boolean;
        amount: string;
        paymentFailureCardData?: {
            paymentIcon?: string;
            iconWidth?: number;
            iconHeight?: number;
            iconAlt?: string;
            title?: string;
            description?: string;
            buttonText?: string;
        };
    };
    collections: {
        [key: string]: IMenuLikeState & {
            id: string;
        };
    };
    crossSell: {
        entries: ICrossSellEntry[];
        config?: CrossSellConfig;
        shownItemIds: string[];
    };
}

export interface IQrCodeAction {
    type: QrCodeActions;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    payload: Record<string, any>;
}

export { QrCodeActions } from "./qrCodeActions";

export type {
    IChoices,
    IAddons,
    IVariation,
    IVariantGroups,
    IVariantsV2,
    ICartItems,
    ILocalCart,
} from "../types/cartTypes";
